export const buildLocalIssueTag = (tagName, noTagType) => {
   const name = String(tagName || '').trim();
   return {
      no: `local:${name.toLowerCase()}`,
      name,
      noTagType,
      local: true
   };
};

export const getIssueCreateErrors = ({ title, location, noPriority }) => ({
   title: !String(title || '').trim(),
   location: !location || location.no == null,
   priority: noPriority == null || noPriority === ''
});

export const hasIssueCreateErrors = (errors) => Boolean(errors.title || errors.location || errors.priority);

export const buildRaiseIssuePayload = ({
   idIssue,
   title,
   description,
   location,
   zonedFor,
   selectedTags,
   noPriority,
   who,
   utcNow
}) => ({
   idIssue,
   title: String(title || '').trim(),
   description: String(description || '').trim() || null,
   noLocation: location.no,
   zonedFor,
   tagNames: (selectedTags || []).map((tag) => tag.name),
   noPriority,
   dueBy: null,
   who,
   utcNow
});
